import { useUserStoreWithOut } from '@/store/modules/user'

/** 将 GUID 统一为小写无连字符格式，避免大小写/格式差异导致匹配失败 */
export function normalizeGid(gid?: string): string {
  return (gid || '').toLowerCase().replace(/-/g, '')
}

/** 解析逗号分隔的 ID 字符串为数组，并对每个 ID 做 normalizeGid */
export function parseIDs(ids?: string): string[] {
  return ids ? ids.split(',').map(s => normalizeGid(s)).filter(Boolean) : []
}

/** 处理图片路径：相对路径拼接登录时获取的图片域名 */
export function resolveImageUrl(path?: string | any): string {
  if (typeof path !== 'string' || !path) return ''
  if (path.startsWith('http://') || path.startsWith('https://') || path.startsWith('data:')) return path
  const domain = sessionStorage.getItem('imageDomain') || useUserStoreWithOut().getImageDomain
  // 去掉 path 开头的 /，防止拼接出双斜杠（domain 末尾已无 /）
  const cleanPath = path.startsWith('/') ? path.slice(1) : path
  if (domain && !domain.includes('localhost') && !domain.includes('127.0.0.1')) {
    return `${domain}/${cleanPath}`
  }
  return import.meta.env.DEV ? `/api/${path}` : `/${path}`
}
